enum Keyword{
    If='IF',
    Then='THEN'
}

export default Keyword;